import cn from 'classnames'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useCallback } from 'react'

import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../translations'

import styles from './PartnerHeadEditMode.module.scss'

interface IPartnerHeadEditModeProps {
  salesCount: Nullable<number>
  serviceCount: Nullable<number>
}

const tooltipMessage = 'This value is required for completeness'
export const PartnerHeadEditMode: FC<IPartnerHeadEditModeProps> = ({
  salesCount,
  serviceCount,
}) => {
  const [formSalesCount] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.salesCount
  )
  const [formServiceCount] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.serviceCount
  )

  const shouldShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const salesCountTooltipCondition =
    shouldShowCompletenessWarning(formSalesCount) && !formSalesCount
  const serviceCountTooltipCondition =
    shouldShowCompletenessWarning(formServiceCount) && !formServiceCount

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <Tooltip
          className={styles.tooltipWrapper}
          disabled={!salesCountTooltipCondition}
          tipContent={tooltipRender}
        >
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.salesCount}
            label={TRANSLATION_KEYS.salesCountLabel}
            defaultValue={salesCount}
            className={cn({
              [styles.warning]: salesCountTooltipCondition,
            })}
          />
        </Tooltip>
      </div>
      <div className={styles.fieldWrapper}>
        <Tooltip
          className={styles.tooltipWrapper}
          disabled={!serviceCountTooltipCondition}
          tipContent={tooltipRender}
        >
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.serviceCount}
            label={TRANSLATION_KEYS.servicesCountLabel}
            defaultValue={serviceCount}
            className={cn({
              [styles.warning]: serviceCountTooltipCondition,
            })}
          />
        </Tooltip>
      </div>
    </div>
  )
}
